



































import Vue from 'vue';
import { MenuItem } from '@/store/types.ts';

export default Vue.extend({
  name: 'UpperBar',
  components: {},
  data() {
    return {
      upperSlickMenu: true
    };
  },
  props: {
    navigationItems: {
      type: Array as () => MenuItem[]
    },
    title: {
      type: String
      //   default: 'FirstTitle'
    },
    firstMenu: {
      type: Boolean
    }
  },
  methods: {
    routeTo(path: string) {
      this.$router.push(path);
    },
    routeToSection(basePath: string, sectionId?: string) {
      if (!sectionId) {
        this.routeTo(basePath);
      } else {
        const path = `${basePath}#${sectionId}`;
        this.$router.push({ path: path });
      }
    },
    toggleLeftMenu() {
      this.$emit('toggleLeftMenu');
    },
    toggleRightMenu() {
      this.$emit('toggleRightMenu');
    }
  }
});
